export function isHeicImageSource(source: string): boolean {
  try {
    return /\.(?:heic|heif)$/iu.test(new URL(source, "https://local.invalid").pathname);
  } catch {
    return false;
  }
}
export function isHeicImageBytes(bytes: Uint8Array): boolean {
  if (bytes.length < 12 || String.fromCharCode(...bytes.subarray(4, 8)) !== "ftyp") return false;
  const brand = String.fromCharCode(...bytes.subarray(8, 12));
  return /^(?:heic|heix|hevc|hevx|heim|heis|hevm|hevs|mif1|msf1)$/u.test(brand);
}
